export enum ServiceOutcomeEnum {
    ABANDON = "ABANDON",
    REJECT = "REJECT",
    SUCCESS = "SUCCESS"
}